// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FpFEw","left":"styles_left__NJqCG","imageCard":"styles_imageCard__NayAb","cashierImg":"styles_cashierImg__P6jbA","right":"styles_right__J9uEA"};